// libraries.
import styled from "styled-components";
import { monserratSemiBold } from "@habitech/shared";

// components.
import { NidInput } from "./components/NidInput";

export const SupportMain = () => {
  return (
    <StyledContainer className="container mt-5">
      <div className="row">
        <div className="col-12">
          <h1 className="main-title text-center mb-4">Soporte</h1>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12 col-md-8 offset-md-2">
          <NidInput />
        </div>
      </div>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  .main-title {
    font-family: ${monserratSemiBold};
    font-size: 32px;
    font-weight: 700;
  }
`;
